import { AutoHeightIframe } from "common/AutoHeightIframe";
import { IeNudgeBar } from "common/banners/IeNudgeBar";
import * as userActions from "lib/api/currentUser";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import styles from "./Upload.scss";

export class _Upload extends React.PureComponent {
  render() {
    const { currentUser, setPreference } = this.props;

    return (
      <div className={styles.Upload}>
        <Helmet title="Upload · Ride with GPS" />
        <IeNudgeBar currentUser={currentUser} setPreference={setPreference} />
        <AutoHeightIframe frameBorder="0" style={{ minHeight: "100vh" }} width="100%" src="/log?dashboard_frame=true" />
      </div>
    );
  }
}

export const Upload = connect((state) => ({ currentUser: state.currentUser }), {
  setPreference: userActions.setPreference,
})(_Upload);
